// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"Buildcontrolcomp_BuildControl__1sYhC","Label":"Buildcontrolcomp_Label__Bxn07","Less":"Buildcontrolcomp_Less__1x238","More":"Buildcontrolcomp_More__2KSaF"};